// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1eo6f","fileBtn":"File_fileBtn__3MNX0","closeBtn":"File_closeBtn__2rovD","fileSelected":"File_fileSelected__1SVkG","disabled":"File_disabled__2nvR8"};